<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field v-model="filter.itemNo" :label="label.itemNo" data-vv-name="itemNo" :data-vv-as="label.itemNo" :error-messages="errors.collect('itemNo')"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn class="mr-2" color="primary" @click.native="doPrint">
            <span>Print Preview</span>
              <v-icon right dark>mdi-printer</v-icon>
          </v-btn>
          <v-btn color="primary" @click.native="doNew">
            New Package Standard Item Text<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.itemNo }} </td>
                <td class="text-xs-left">{{ row.item.stdRiskItemTxt }} </td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery(row.item)" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
        <confirm v-model="promptRemove" @ok="doDelete">
          <p>Are you sure you want to delete the Tariff Rate?</p>
          <div class="queryValue">Scheme: {{selected.scheme}}<br/>
            Risk No.: {{selected.riskNo}}<br/>
            Item No.: {{selected.itemNo}}<br/>
            Standard Risk Item Text: {{selected.stdRiskItemTxt}}<br/>
          </div>
         </confirm>
      </v-card>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      label: {
        pkgSdRTxtScheme: 'Scheme',
        pkgSdRTxtRiskNo: 'Risk No.',
        itemNo: 'Item No.'
      },
      filter: {
        itemNo: null,
        pkgSdRTxtScheme: null,
        pkgSdRTxtRiskNo: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Item No.', align: 'left', value: 'itemNo' },
        { text: 'Standard Risk Item Text', align: 'left', value: 'stdRiskItemTxt' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selected: {
        scheme: null,
        riskNo: null,
        itemNo: null,
        stdRiskItemTxt: null
      },
      dto: {
        pkgSdRTxtScheme: null,
        pkgSdRTxtRiskNo: null,
        stdRiskTxtRef: null,
        format: null,
        customName: null,
        sendEmail: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('pkgStdRiskTxtInit')
    await this.$store.dispatch('pkgStdItemTxtInit')
    this.doInit()
  },
  methods: {
    async doInit() {
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getPkgStdItemTxtList
      this.filter.pkgSdRTxtScheme = this.pkgStdRiskTxtId.scheme
      this.filter.pkgSdRTxtRiskNo = this.pkgStdRiskTxtId.riskNo
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map(datamap => {
                const convertList = {
                  scheme: datamap.scheme,
                  riskNo: datamap.riskNo,
                  itemNo: datamap.itemNo,
                  stdRiskTxtRef: datamap.pkgStdRiskTxt,
                  stdRiskItemTxt: datamap.stdRiskItemTxt
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.filter.itemNo = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        scheme: this.pkgStdRiskTxtId.scheme,
        riskNo: this.pkgStdRiskTxtId.riskNo,
        stdRiskTxtRef: this.pkgStdRiskTxtId.stdRiskTxtRef,
        itemNo: null,
        stdRiskItemTxt: null
      }
      sessionStorage.setItem('pkgStdItemTxt', JSON.stringify(commit))
      this.$store.commit('PKGSTDITEMTXT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgStdItemTxtReview' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        scheme: data.scheme,
        riskNo: data.riskNo,
        itemNo: data.itemNo,
        stdRiskTxtRef: data.stdRiskTxtRef,
        stdRiskItemTxt: data.stdRiskItemTxt
      }
      sessionStorage.setItem('pkgStdItemTxt', JSON.stringify(commit))
      this.$store.commit('PKGSTDITEMTXT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgStdItemTxtReview' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        scheme: data.scheme,
        riskNo: data.riskNo,
        itemNo: data.itemNo,
        stdRiskTxtRef: data.stdRiskTxtRef,
        stdRiskItemTxt: data.stdRiskItemTxt
      }
      sessionStorage.setItem('pkgStdItemTxt', JSON.stringify(commit))
      this.$store.commit('PKGSTDITEMTXT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgStdItemTxtReview' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeletePkgStdItemTxt
          const expand = {
            scheme: data.scheme,
            riskNo: data.riskNo,
            itemNo: data.itemNo
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selected.scheme = data.scheme
          this.selected.riskNo = data.riskNo
          this.selected.itemNo = data.itemNo
          this.selected.stdRiskItemTxt = data.stdRiskItemTxt
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.itemNo) {
        const apiURI = this.menu.deletePkgStdItemTxt
        if (apiURI) {
          const expand = {
            scheme: this.selected.scheme,
            riskNo: this.selected.riskNo,
            itemNo: this.selected.itemNo
          }
          this.$http.post(apiURI, expand).then(result => {
            const data = result.data
            this.notify(data)
            this.promptRemove = false
            this.doInit()
          }).catch(err => {
            this.promptRemove = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
        }
      }
    },
    async doPrint() {
      this.doExportPkgSItemTxtRecord()
    },
    async doExportPkgSItemTxtRecord() {
      const apiURI = this.menu.exportPkgSItemTxtRpt
      if (apiURI) {
        try {
          this.dto.pkgSdRTxtScheme = this.filter.pkgSdRTxtScheme
          this.dto.pkgSdRTxtRiskNo = this.filter.pkgSdRTxtRiskNo
          this.dto.stdRiskTxtRef = this.pkgStdRiskTxtId.stdRiskTxtRef
          this.dto.format = 'PDF'
          this.dto.customName = ''
          this.dto.sendEmail = false
          let messageFilters = clone(this.dto)
          await this.$http.post(apiURI, messageFilters)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('pkgStdRiskTxt'))
    this.$store.commit('PKGSTDRISKTXT_COMMIT_KEY', jsonData)
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.pkgStdItemTxt.menu
    },
    pkgStdRiskTxtId() {
      return this.$store.state.pkgParam.pkgStdRiskTxt.pkgStdRiskTxtId
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    commonAjaxMixin
  ]
}
</script>
